import type { HexRenderContext } from './hexRenderTypes';
import { hexCenter, hexPath } from '../common/geometry';

export class UnknownHex {
    render({ ctx, verts, zoom }: HexRenderContext): void {
        const center = hexCenter(verts);
        hexPath(ctx, verts);
        ctx.fillStyle = '#4a4a4a';
        ctx.fill();
        ctx.lineWidth = 1.2 / zoom;
        ctx.strokeStyle = 'rgba(0,0,0,0.55)';
        ctx.stroke();

        ctx.font = `${14 / zoom}px monospace`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = 'rgba(255,255,255,0.75)';
        ctx.fillText('?', center.x, center.y);
    }
}
